export default "__VITE_ASSET__CSvNQwrR__"